<template>
  <div class="accountInfo" :class="isScroll?'':'isBackground'">
    <Header :title="title" :right-content="rightContent" />
    <div id="content">
      <div class="layout">
        <div v-if="isPrompt" class="prompt between2">
          <span>
            <img src="@/assets/images/template/a_top_remind.png">
            只有激活的账户才能申请账户升级
          </span>
          <img src="@/assets/images/template/close_1.png" @click="closePrompt">
        </div>
        <div v-if="currentAccount" class="infoCon">
          <ul>
            <li><p>账户账号</p><p>{{ currentAccount.accountNo }}</p></li>
            <li><p>账户状态</p><p>{{ currentAccount.accountStatusName }}</p></button></li>
            <li><p @click="goAccLevel(currentAccount.accountLevel)">账户级别<img src="@/assets/images/template/remind.png"></p><p>{{ altFlavors.includes(flavor) && currentAccount.accountLevelName == "巴菲特" ? "特选" : currentAccount.accountLevelName }}</p></li>
            <li><p>账户余额</p><p>{{ balance }}美元</p></li>
          </ul>
          <div v-if="currentAccount.accountStatusName=='未激活'" v-sa="{'ClickDeposit':{'PType':pageType=='app'?'app端':pageType=='trade'?'H5交易':'用户中心','AccountType':'真实账户','entry':'账户信息-存款'}}" class="submit" @click="goRecharge"><span>去激活</span></div>
          <div v-else class="btn" :class="currentAccount.accountLevel=='ZER'||newAccountLevel==''?'only':''"><span v-sa="{'ClickDeposit':{'PType':pageType=='app'?'app端':pageType=='trade'?'H5交易':'用户中心','AccountType':'真实账户','entry':'账户信息-存款'}}" @click="goRecharge">存款</span><span v-if="currentAccount.accountLevel!='ZER'&&newAccountLevel!=''" @click="getNextAccountLevel(currentAccount.accountLevel)">升级</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
require('@/assets/css/accInfo.css')
import Header from '@/view/module/Header.vue'
import api from '@/plugins/api'
import { mapState } from 'vuex'
export default {
  name: 'AccInfo',
  components: { Header },
  computed: {
    ...mapState(['gts2CustomerId', 'pageType', 'gts2AccountId', 'platform', 'altFlavors'])
  },
  data() {
    return {
      title: '交易平台',
      rightContent: 'isNo',
      isScroll: '',
      accTradeInfoList: '',
      balance: '',
      isPrompt: false,
      newAccountLevel: '',
      statusNameList: [],
      flavor: this.$route.query.flavor,
      currentAccount: null
    }
  },
  mounted() {
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.hasScrollbar()
    this.getAccountLevel()
    this.AccTradeInfo()
  },
  activated() {
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.hasScrollbar()
  },
  methods: {
    hasScrollbar() {
      if (document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight)) {
        this.isScroll = true
      } else this.isScroll = false
      return this.isScroll
    },
    closePrompt() {
      this.isPrompt = false
    },
    goAccLevel(accountLevel) {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/accLevel', query: { accountLevel: accountLevel, flavor: this.$route.query.flavor }})
    },
    getAccountLevel() {
      api.getAccountLevelByGts2AccountId(this.gts2AccountId).then(res => {
        if (res.status == 200 && res.data.code == 200) {
          if (res.data.data) {
            for (const i in res.data.data) {
              this.newAccountLevel = i
            }
          }
        }
      })
    },
    AccTradeInfo() {
      api.getAccTradeInfo(this.gts2CustomerId).then(res => {
        if (res.data.code == 200) {
          this.balance = res.data.data.accountSummary.totalMoney
          this.accTradeInfoList = res.data.data.accTradeInfoList
          this.currentAccount = this.accTradeInfoList[0]
          for (const i in this.accTradeInfoList) {
            if (this.accTradeInfoList[i].accountStatusName == '未激活') this.statusNameList.push(i)
            if (this.statusNameList.length > 0) this.isPrompt = true
            else this.isPrompt = false
          }
        }
      })
    },
    goRecharge() {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/recharge' })
    },
    getNextAccountLevel(accountLevel) {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/accUpgrade', query: { accountLevel: accountLevel, flavor: this.flavor }})
    }
  }
}
</script>
